import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.css';

import aniPhoto1 from 'img/gameEntrance/photo1.webp';
import aniPhoto2 from 'img/gameEntrance/photo2.webp';
import aniPhoto3 from 'img/gameEntrance/photo3.webp';
import aniPhoto4 from 'img/gameEntrance/photo4.webp';
import aniPhoto5 from 'img/gameEntrance/photo5.webp';
import aniPhoto6 from 'img/gameEntrance/photo5-2.webp';

const GameEmntranceDefault = () => {
  const {t} = useTranslation();
  const photoType = [
    { key: 0, classes: 'inBox box1', photo: aniPhoto1, photo2: null, dis: t('GameEntrance.dis1')},
    { key: 1, classes: 'inBox box2', photo: aniPhoto2, photo2: null, dis: t('GameEntrance.dis2')},
    { key: 2, classes: 'inBox box3', photo: aniPhoto3, photo2: null, dis: t('GameEntrance.dis3')},
    { key: 3, classes: 'inBox box4', photo: aniPhoto4, photo2: null, dis: t('GameEntrance.dis4')},
    { key: 4, classes: 'inBox box5', photo: aniPhoto5, photo2: aniPhoto6, dis: t('GameEntrance.dis5')}
  ]

  return(
    <div className="geBox">
      {photoType.map(({key, classes, photo,photo2,dis}) => (
        <a className={classes} key={key}>
          <div>
            <img className="photo1" src={photo} alt="" />
            <img className="photo2" src={photo2} alt=""  />
            <p>{dis}</p>
          </div>
        </a>
      ))}
    </div>
  )
}

export default GameEmntranceDefault
